<template>
    <div class="airportTopMenu" >
        
        <div class="line"></div>
        <div class="left"></div>
        <div class="middle">湘西边城机场智慧能源管控平台</div>
        <div class="right">
            <div class="now-timer">
                <div class="week">星期四</div>
                <div class="hour">10:25:50</div>
                <div class="date">2022-10-20</div>
            </div>
            <div class="btns">
                <div class="item" @click="exitFullScreen">
                    <img src="../../../assets/airportTopMenu/enlarge.png" alt="全屏">
                </div>
                 <div class="item" >
                    <img src="../../../assets/airportTopMenu/refresh.png" alt="">
                </div>
                 <div class="item">
                    <img src="../../../assets/airportTopMenu/user.png" alt="">
                </div>
                 <div class="item" @click="logout">
                    <img src="../../../assets/airportTopMenu/out.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
          
        }
    },
    created(){
   
    },
    watch:{

    },
    methods:{
        clickLiFun(i){
            this.liIndex = i
            this.$router.push(this.liData[i].router)
        },
        logout(){
            // console.log("退出登陆");
            this.shouMenus = false
            this.$store.menuStore.commit('clear')
				this.$dialogMethod.showLoading("正在注销...")
				this.$api.userApi.logout(respon => {
					//清理所有缓存
					toLogin()
				})
        },
        exitFullScreen(){
             this.$store.menuStore.commit('exitFullScreen')
        }
    }
}
</script>

<style lang="scss" scoped>
.airportTopMenu {

    height: 90px;
    background-color: #2b3745;
    z-index: 999;
     .line {
        position: absolute;
        top: 13px;
        left: 3px;
       width: 100%;
       height: 75px;
        background: url(../../../assets/airportTopMenu/曲线.png) no-repeat;
         background-size: 100% 100%;
    }
    .left,.right {
        position: absolute;
        top: 23px;
        width: 580px;
        height: 60px;
        background-size: 100% 100%;
    }
    .left {
        left: 0;
         background: url(../../../assets/airportTopMenu/left.png) no-repeat;
    }
    .middle {
        width: 880px;
        height: 80px;
        position: absolute;
        left: 50%;
        top: 3px;
        transform: translateX(-50%);
        background: url(../../../assets/airportTopMenu/title.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 100px;
        color: #fff;
        font-size: 36px;
        font-weight: bold;
    }
     .right {
        right: 0;
         background: url(../../../assets/airportTopMenu/right.png) no-repeat;
         display: flex;
         .now-timer {
            display: flex;
            align-items: center;
            margin-left: 85px;
            color: #fff;
            font-weight: bold;
            div{
                font-size: 16px;

            }
            .hour {
                margin: 0px 12px;
            }
         }
         .btns {
            display: flex;
            align-items: center;
            margin-left: 20px;
            .item {
              display: flex;
              align-items: center;
              margin-left: 20px;
              cursor: pointer;
            }
         }

    }
}
</style>